import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import LockIcon from '@mui/icons-material/Lock';
import { Avatar, IconButton, ListItemIcon, Menu, MenuItem, Typography } from '@mui/material';
import { Button } from "@progress/kendo-react-buttons";
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { menuIcon } from "@progress/kendo-svg-icons";
import React from "react";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Images from '../../../custom/flagExport';
import AutodapLogo from "../../../images/logo/autodap.png";
import { encryptData } from "../../../services/dashboard-service/encryptionService";


const regions = [
    { id: 6, name: 'English', value: 'en', flag: Images["uk"] },
    { id: 2, name: 'Svenska ', value: "sv", flag: Images["se"] },
    { id: 1, name: 'Suomi', value: "fi", flag: Images["fi"] },
];

const itemRender = (li, itemProps) => {
    const item = itemProps.dataItem;
    return (
        <li {...li.props} className="region-item" style={{ cursor: "pointer", width: "150px", zIndex: 100000, marginBottom: "10px", marginTop: '5px' }}>
            <img src={item.flag} alt={item.name} style={{ width: '30px', height: "20px", marginRight: '10px' }} />
            {item.name}
        </li>

    );
};

const valueRender = (li, itemProps) => {
    if (!itemProps) return null;
    return (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "start", width: "130px", padding: "10px 0px 10px 5px", borderRadius: "50px", marginRight: "0px" }}>
            <img src={itemProps.flag} alt={itemProps.name} style={{ width: '30px', height: "20px", margin: '0 10px' }} />
            {itemProps.name.toUpperCase()}
        </div>
    )
}

const Navbar = React.memo(({ user, setSelectedRegion, setDrawerExpanded, setUser, selectedRegion, renderRoute }) => {
    const navigate = useNavigate()
    const { i18n } = useTranslation();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const dropdownRef = React.useRef(null);
    const name = user?.FirstName?.charAt(0)?.toUpperCase()

    const changeLang = (lang) => {
        i18n.changeLanguage(lang.value);
        const encryptedLang = encryptData(JSON.stringify(lang.value));
        localStorage.setItem("CurrentLanguage", encryptedLang);
        const region = regions.find(r => r.value === lang.value);
        setSelectedRegion(region);
    }

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleProfileClick = () => {
        navigate('/user-profile')
        handleMenuClose();
    };

    const handleChangePasswordClick = () => {
        navigate('/change-password')
        handleMenuClose();
    };


    const handleClick = () => {
        setDrawerExpanded(prev => !prev);
    };

    const handleLogout = () => {
        localStorage.removeItem("userData");
        localStorage.removeItem("chat_id");
        localStorage.removeItem("currentChats");
        localStorage.removeItem("CurrentLanguage");
        localStorage.removeItem("selectedParts");
        sessionStorage.clear()
        setUser(null)
        handleMenuClose();
        navigate('/login');
    };


    return (
        <div className="custom-toolbar">
            <div className='custom-navbar'>
                <Button svgIcon={menuIcon} style={{ boxShadow: "none", outline: "none", outlineColor: "none" }} fillMode="flat" onClick={handleClick} />
                <img alt="Autodap Logo" onClick={() => navigate(renderRoute)} src={AutodapLogo} style={{ height: '50px', marginLeft: '0px', cursor: "pointer" }} />
                <div style={{ position: 'relative', display: 'inline-flex', marginLeft: 'auto', alignItems: "cetner" }} ref={dropdownRef} className='dropdown-flag'>
                    <DropDownList
                        data={regions}
                        textField="name"
                        value={selectedRegion}
                        onChange={(e) => changeLang(e.target.value)}
                        valueRender={valueRender}
                        itemRender={itemRender}
                        style={{ marginRight: "0px" }}
                    />
                    <div>
                        {/* Trigger Button */}
                        <IconButton
                            onClick={handleMenuOpen}
                            size="medium"
                            aria-controls={open ? 'user-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? 'true' : undefined}
                        >
                            <Avatar alt="User Avatar" sx={{ width: "30px", height: "30px" }} >{name ? name : null}</Avatar>
                        </IconButton>

                        {/* Menu */}
                        <Menu
                            id="user-menu"
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleMenuClose}
                            MenuListProps={{
                                'aria-labelledby': 'user-menu-button',
                            }}
                            sx={{
                                zIndex: 999999
                            }}
                            PaperProps={{
                                style: {
                                    left: 'calc(100% - 150px)', // Custom left positioning
                                    top: '50px', // Custom top positioning
                                },
                            }}
                        >
                            {/* Profile Menu Item */}
                            <MenuItem onClick={handleProfileClick}>
                                <ListItemIcon>
                                    <AccountCircleIcon fontSize="small" />
                                </ListItemIcon>
                                <Typography variant="inherit">User Profile</Typography>
                            </MenuItem>

                            {/* Change Password Menu Item */}
                            <MenuItem onClick={handleChangePasswordClick}>
                                <ListItemIcon>
                                    <LockIcon fontSize="small" />
                                </ListItemIcon>
                                <Typography variant="inherit">Change Password</Typography>
                            </MenuItem>

                            {/* Logout Menu Item */}
                            <MenuItem onClick={handleLogout}>
                                <ListItemIcon>
                                    <ExitToAppIcon fontSize="small" />
                                </ListItemIcon>
                                <Typography variant="inherit">Logout</Typography>
                            </MenuItem>
                        </Menu>
                    </div>
                </div>
            </div>
        </div>
    )
})

export default Navbar